import hat from "./hat";
import hijab from "./hijab";
import blank from "./blank";
import turban from "./turban";
import winterHat1 from "./winter-hat-1";
import winterHat2 from "./winter-hat-2";
import winterHat3 from "./winter-hat-3";
import winterHat4 from "./winter-hat-4";

import longHairBig from "./long-hair-big";
import longHairBob from "./long-hair-bob";
import longHairBun from "./long-hair-bun";
import longHairCurly from "./long-hair-curly";
import longHairCurvy from "./long-hair-curvy";
import longHairDreads from "./long-hair-dreads";
import longHairFrida from "./long-hair-frida";
import longHairFroBand from "./long-hair-fro-band";
import longHairFro from "./long-hair-fro";
import longHairMiaWallace from "./long-hair-mia-wallace";
import longHairNotTooLong from "./long-hair-not-too-long";
import longHairShavedSides from "./long-hair-shaved-sides";
import longHairStraight01 from "./long-hair-straight-01";
import longHairStraight02 from "./long-hair-straight-02";
import longHairStraightStrand from "./long-hair-straight-strand";
import shortHairDreads01 from "./short-hair-dreads-01";
import shortHairDreads02 from "./short-hair-dreads-02";
import shortHairFrizzle from "./short-hair-frizzle";
import shortHairShaggyMullet from "./short-hair-shaggy-mullet";
import shortHairShaggy from "./short-hair-shaggy";
import shortHairShortCurly from "./short-hair-short-curly";
import shortHairShortFlat from "./short-hair-short-flat";
import shortHairShortRound from "./short-hair-short-round";
import shortHairShortWaved from "./short-hair-short-waved";
import shortHairSides from "./short-hair-sides";
import shortHairTheCaesarSidePart from "./short-hair-the-caesar-side-part";
import shortHairTheCaesar from "./short-hair-the-caesar";


export default {
	blank,
	hat,
	hijab,
	turban,
	winterHat1,
	winterHat2,
	winterHat3,
	winterHat4,
	longHairBig,
	longHairBob,
	longHairBun,
	longHairCurly,
	longHairCurvy,
	longHairDreads,
	longHairFrida,
	longHairFroBand,
	longHairFro,
	longHairMiaWallace,
	longHairNotTooLong,
	longHairShavedSides,
	longHairStraight01,
	longHairStraight02,
	longHairStraightStrand,
	shortHairDreads01,
	shortHairDreads02,
	shortHairFrizzle,
	shortHairShaggyMullet,
	shortHairShaggy,
	shortHairShortCurly,
	shortHairShortFlat,
	shortHairShortRound,
	shortHairShortWaved,
	shortHairSides,
	shortHairTheCaesarSidePart,
	shortHairTheCaesar,
};



// WEBPACK FOOTER //
// ./src/top/index.js